module.exports = __webpack_public_path__ + "static/BrandonGrotesque-LightItalic-f7fc93b5f035c692073e8d941d453539.woff2";